import useExportVideo from '../../hooks/useSubscription/useExportVideo';
import styles from './ExportVideo.module.css';

export enum startExportErrorTypes {
  alreadyProcessing,
  lengthExceeded,
  feedCardsExceeded,
}

type Props = {
  type: startExportErrorTypes;
};

const ExportVideoStartError = ({ type }: Props) => {
  const { exportState } = useExportVideo();

  let errorMsg;
  if (type === startExportErrorTypes.alreadyProcessing) {
    errorMsg =
      'There is currently an export to video in progress. Please wait for that to\n' +
      '      finish before exporting another giide.';
  } else if (type === startExportErrorTypes.lengthExceeded) {
    errorMsg =
      "We're sorry, but at this time only giides less than 5 minutes in length are eligible for export. If you have any questions, please contact us.";
  } else if (type === startExportErrorTypes.feedCardsExceeded) {
    errorMsg =
      "We're sorry, but at this time only giides with less than 97 feed cards are eligible for export. If you have any questions, please contact us.";
  }

  return (
    <div className={styles.exportVideoStart}>
      <h4>{exportState.requestedGiideTitle}</h4>
      <div>{errorMsg}</div>
    </div>
  );
};

export default ExportVideoStartError;
